import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";

import AutocompleteInput from "components/Input/AutocompleteInput.js";

import { site } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";
import {getFiles, getSite} from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
}));

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function SelectedFiles(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [prevData, setPrevData] = useState();

  const {
    closeModal,
    refetch,
    clef,
    comments,
    external,
    description,
    ged,
    email,
    name,
    status,
    role,
    company,
    phone,
    handleAssociatedfilesChange,
  } = props;

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup,'contact'),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail.contact?.contactlist);
      });
  }, []);

  const handleSubmit = async (event) => {
    const indexToReplace = prevData.findIndex((x) => x.email === email);

    const newData = {
      clef,
      comments,
      external,
      description,
      ged,
      email,
      name,
      status,
      role,
      company,
      phone,
    };

    const contactlist = prevData;
    contactlist.splice(indexToReplace, 1, newData);

    axios
      .put(
        getSite(chartIdGroup,'contact'),
        { contactlist },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
      })
      .catch(() => {});
  };

  const selectedGed = () => {
    let gedCardId = [];

    console.log(ged);

    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }

      console.log(gedCardId);

      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );

      console.log(getGedNames);
    }
    console.log(getGedNames);
    return getGedNames;
  };
  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <AutocompleteInput
                inputTitle={site.contact.contactlist.associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default SelectedFiles;
